'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n    font-size: 14px;\n  '], ['\n    font-size: 14px;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n    font-size: 16px;\n  '], ['\n    font-size: 16px;\n  ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    font-size: 18px;\n  '], ['\n    font-size: 18px;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n    font-size: 20px;\n  '], ['\n    font-size: 20px;\n  ']),
    _templateObject5 = _taggedTemplateLiteral(['\n    font-size: 22px;\n  '], ['\n    font-size: 22px;\n  ']),
    _templateObject6 = _taggedTemplateLiteral(['\n    font-size: 26px;\n  '], ['\n    font-size: 26px;\n  ']),
    _templateObject7 = _taggedTemplateLiteral(['\n    font-size: inherit;\n  '], ['\n    font-size: inherit;\n  ']),
    _templateObject8 = _taggedTemplateLiteral(['\n    font-weight: 300;\n  '], ['\n    font-weight: 300;\n  ']),
    _templateObject9 = _taggedTemplateLiteral(['\n    font-weight: 400;\n  '], ['\n    font-weight: 400;\n  ']),
    _templateObject10 = _taggedTemplateLiteral(['\n    font-weight: 500;\n  '], ['\n    font-weight: 500;\n  ']),
    _templateObject11 = _taggedTemplateLiteral(['\n    font-weight: 700;\n  '], ['\n    font-weight: 700;\n  ']),
    _templateObject12 = _taggedTemplateLiteral(['\n    text-align: ', ';\n  '], ['\n    text-align: ', ';\n  ']),
    _templateObject13 = _taggedTemplateLiteral(['\n  display: ', ';\n  color: ', ';\n  text-transform: ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  display: ', ';\n  color: ', ';\n  text-transform: ', ';\n  ', ';\n  ', ';\n  ', ';\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('../../libs/colors');

var colors = _interopRequireWildcard(_colors);

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Colors
// Helpers


var sizes = {
  '1': (0, _styledComponents.css)(_templateObject),
  '2': (0, _styledComponents.css)(_templateObject2),
  '3': (0, _styledComponents.css)(_templateObject3),
  '4': (0, _styledComponents.css)(_templateObject4),
  '5': (0, _styledComponents.css)(_templateObject5),
  '6': (0, _styledComponents.css)(_templateObject6),
  inherit: (0, _styledComponents.css)(_templateObject7)
};
var fontWeight = {
  thin: (0, _styledComponents.css)(_templateObject8),
  normal: (0, _styledComponents.css)(_templateObject9),
  medium: (0, _styledComponents.css)(_templateObject10),
  bold: (0, _styledComponents.css)(_templateObject11)
};

var alignment = function alignment(_ref) {
  var align = _ref.align;
  return (0, _styledComponents.css)(_templateObject12, align);
};

var P = _styledComponents2.default.div(_templateObject13, function (_ref2) {
  var inline = _ref2.inline;
  return inline ? 'inline-block' : 'block';
}, function (_ref3) {
  var theme = _ref3.theme;
  return colors[theme];
}, function (_ref4) {
  var uppercase = _ref4.uppercase;
  return uppercase ? 'uppercase' : 'none';
}, function (_ref5) {
  var size = _ref5.size;
  return sizes[size];
}, function (_ref6) {
  var weight = _ref6.weight;
  return fontWeight[weight];
}, alignment);

var Paragraph = function (_Component) {
  _inherits(Paragraph, _Component);

  function Paragraph() {
    _classCallCheck(this, Paragraph);

    return _possibleConstructorReturn(this, (Paragraph.__proto__ || Object.getPrototypeOf(Paragraph)).apply(this, arguments));
  }

  _createClass(Paragraph, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          props = _objectWithoutProperties(_props, ['children']);

      return _react2.default.createElement(P, props, children);
    }
  }]);

  return Paragraph;
}(_react.Component);

Paragraph.propTypes = {
  children: _propTypes2.default.node,
  size: _propTypes2.default.oneOf(['1', '2', '3', '4', '5', '6', 'inherit']),
  weight: _propTypes2.default.oneOf(['thin', 'normal', 'medium', 'bold']),
  theme: _propTypes2.default.oneOf(Object.keys(colors)),
  align: _propTypes2.default.oneOf(['left', 'center', 'right', 'justify']),
  inline: _propTypes2.default.bool,
  uppercase: _propTypes2.default.bool
};
Paragraph.defaultProps = {
  size: '1',
  weight: 'normal',
  theme: 'black',
  align: 'left',
  inline: false,
  uppercase: false
};
exports.default = Paragraph;